export default __webpack_public_path__ + "6ae99f53abdb2bd9c01bcd3fda072e3e.svg";